import axios from 'axios';
import {
  GET_UNREAD_MESSAGES_COUNT,
  GET_CURRENT_CONVERSATION,
  GET_CONVERSATION_LIST,
  UPDATE_UNREAD_MESSAGES_COUNT,
  HIDE_CHAT_ROOM,
  PIN_CHAT,
  UNPIN_CHAT,
  CURRENT_CHAT_ROOM_ID,
} from './types';
import store from '../../../store';
import {
  NEW_MESSAGE
} from '../../../store/types';

import api from '../../../utils/api';
import SocketConnect from '../../../utils/socket';

export default {
  setStartTyping(_commit, data) {
    const socket = new SocketConnect();
    socket.emit('start_typing', data);
  },
  setEndTyping(_commit, data) {
    const socket = new SocketConnect();
    socket.emit('end_typing', data);
  },
  setAsSeenMessage({ commit }, data) {
    const socket = new SocketConnect();
    socket.emit('read_message', data);
    commit( CURRENT_CHAT_ROOM_ID, data.chats[0] )
  },
  setAsUnreadMessage(_, data) {
    const socket = new SocketConnect();
    socket.emit('unread_message', data);
  },
  async sendNewMessage({}, { messageData }) {
    const socket = new SocketConnect();
    socket.emit('new_message', messageData);
  },
  getChatUnreadMsgCount({ commit }, count) {
    commit(UPDATE_UNREAD_MESSAGES_COUNT, count);
  },
  async getUnreadMessagesCount({ commit }) {
    const { data } = await axios(api.messages.getUnreadMessagesCount());
    commit(GET_UNREAD_MESSAGES_COUNT, data.result.count);
  },
  async getChatRoomId(_, receiverId) {
    const { data } = await axios(api.messages.getChatRoomId(receiverId));
    return data.result.chat_room_id;
  },
  async fetchAllUsersForChat({}, name = '', page = 1) {
    const { data } = await axios(api.messages.fetchAllUsersForChat(name, page));
    return data;
  },
  async createNewConversation({}, conversation) {
    const { data } = await axios(api.messages.createNewConversation(conversation));
    return data;
  },
  async getConversationList({ commit }, { conversationId, page }) {
    const { data } = await axios(api.messages.conversationList(conversationId, page));
    commit(GET_CONVERSATION_LIST, { conversations: data.result.docs, page });
    return data;
  },
  async getCurrentChatDetails({}, conversationId) {
    const { data } = await axios(api.messages.currentChatDetails(conversationId));
    return data;
  },
  async getCurrentConversation({ commit }, { chatRoomId, page }) {
    const { data } = await axios(api.messages.currentConversation(chatRoomId, page));
    commit(GET_CURRENT_CONVERSATION, { conversation: data.result.docs, page });
    return data;
  },
  async searchGlobalMessages({}, searchValue) {
    const { data } = await axios(api.messages.searchGlobalMessages(searchValue));
    return data;
  },
  async searchConversationMessages({}, chatRoomId, searchValue) {
    const { data } = await axios(api.messages.searchConversationMessages(chatRoomId, searchValue));
    return data;
  },
  async pinMessageToTop({ commit }, chatsData) {
    const { data } = await axios(api.messages.pinMessageToTop(chatsData));
    commit(PIN_CHAT, { chatIds: chatsData.chats });
    return data;
  },
  async unPinMessage({ commit }, chatsData) {
    const { data } = await axios(api.messages.unPinMessage(chatsData));
    commit(UNPIN_CHAT, { chatIds: chatsData.chats });
    return data;
  },
  async blockConversation({ commit }, chatsData) {
    const { data } = await axios(api.messages.blockConversation(chatsData));
    commit(HIDE_CHAT_ROOM, { chatIds: chatsData.chats });
    return data;
  },
  async unblockConversation({}, msgId) {
    const { data } = await axios(api.messages.unblockConversation(msgId));
    return data;
  },
  async blacklist({}) {
    const { data } = await axios(api.messages.blacklist());
    return data;
  },
  async hideConversation({ commit }, chatsData) {
    const { data } = await axios(api.messages.hideConversation(chatsData));
    commit(HIDE_CHAT_ROOM, { chatIds: chatsData.chats });
    return data;
  },
  async sendMessageViaNodeJSServer({}, messageData) {
    const { data } = await axios(api.messages.sendMessageViaNodeJSServer(messageData));
    return data;
  },
  sendMessageToCurrentUser({}, messageData) {
    store.commit(NEW_MESSAGE, messageData);
  },
  async removeConversation({ commit }, chatsData) {
    const { data } = await axios(api.messages.removeConversation(chatsData.chatConversations[0]));
    commit(HIDE_CHAT_ROOM, { chatIds: chatsData.chats });
    return data;
  }
};
